/* ==========================================================================
   ALMAM - marimile epuizate primesc clasa `disabled`
   ==========================================================================
   Tema stinge si taie o marime epuizata prin clasa `disabled` pusa pe
   `<input type="radio">` (stilul e in `product-form-input.css`, iar taietura
   diagonala in `section-main-product-almam.css` si `section-quick-view.css`).
   Clasa insa nu ajungea niciodata acolo in doua situatii:

   1. In fereastra de adaugare rapida. `QuickVariantSelects` din
      `assets/quick_view_modal.js` nu are deloc metodele `updateVariantStatuses`
      / `setInputAvailability` - a fost copiata din `product-variant.js` fara
      ele. Deci in fereastra toate marimile aratau la fel, si cele epuizate, si
      cele pe stoc.

   2. La INCARCAREA paginii de produs. `product-variant.js` cheama
      `updateVariantStatuses` doar din `onVariantChange`, deci marimile se taiau
      abia dupa ce atingeai o optiune. Cine deschidea pagina si se uita nu vedea
      nimic taiat.

   Fisierul nu inlocuieste nimic din tema: doar pune aceeasi clasa, la
   incarcare si la fiecare schimbare. Codul temei ramane neatins, ca o
   actualizare a temei sa nu il duca cu ea.

   Regula de disponibilitate e cea standard: o valoare a optiunii de pe pozitia
   N e disponibila daca exista macar o varianta pe stoc care are exact valorile
   alese pentru optiunile 1..N-1 si valoarea aceea pe pozitia N.
   ========================================================================== */

(function () {
  'use strict';

  var ROOT_SELECTOR = 'variant-radios, quick-variant-radios';

  /* Valorile din `value=""` vin din Liquid, cele din JSON vin de la Shopify.
     Se compara curatate la capete: `variant-radios.liquid` scrie valoarea bruta
     a optiunii, iar `quick-view-variant-color-swatch.liquid` o trece prin
     `strip`. Fara curatare, o optiune scrisa cu spatiu la coada in admin nu s-ar
     potrivi niciodata si TOATE marimile ar aparea epuizate. */
  function normalize(value) {
    return value == null ? '' : String(value).trim();
  }

  function readVariants(root) {
    if (root.almamVariantData !== undefined) return root.almamVariantData;

    var holder = root.querySelector('[data-variant]');
    root.almamVariantData = null;

    if (holder) {
      try {
        root.almamVariantData = JSON.parse(holder.textContent);
      } catch (error) {
        root.almamVariantData = null;
      }
    }

    return root.almamVariantData;
  }

  /* Optiunea de culoare se sare: pastilele ei sunt cercuri, iar o diagonala
     inscrisa intr-un patrat le-ar depasi conturul. Recunoasterea se face dupa
     forma etichetei, nu dupa numele optiunii: numele difera de la produs la
     produs („Culoare" la unele, „Color" la altele), forma nu. */
  function isSwatchFieldset(fieldset) {
    return fieldset.querySelector('label[class*="variant--swatch"]') !== null;
  }

  function checkedValue(fieldset) {
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? normalize(checked.value) : null;
  }

  function update(root) {
    var variants = readVariants(root);
    if (!variants || !variants.length) return;

    var fieldsets = Array.prototype.slice.call(
      root.querySelectorAll('fieldset.product-form__input')
    );

    fieldsets.forEach(function (fieldset, position) {
      if (isSwatchFieldset(fieldset)) return;

      /* Valorile alese pentru optiunile DINAINTEA acesteia. Daca vreuna nu are
         nimic bifat, nu se poate spune ce e disponibil, deci nu se atinge
         nimic - mai bine nemarcat decat marcat gresit. */
      var prefix = [];
      var incomplete = false;

      for (var i = 0; i < position; i++) {
        var value = checkedValue(fieldsets[i]);
        if (value === null) incomplete = true;
        prefix.push(value);
      }

      if (incomplete) return;

      var available = Object.create(null);

      variants.forEach(function (variant) {
        if (!variant.available) return;

        for (var i = 0; i < prefix.length; i++) {
          if (normalize(variant.options[i]) !== prefix[i]) return;
        }

        available[normalize(variant.options[position])] = true;
      });

      Array.prototype.forEach.call(
        fieldset.querySelectorAll('input[type="radio"]'),
        function (input) {
          input.classList.toggle('disabled', !available[normalize(input.value)]);
        }
      );
    });
  }

  function updateAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll(ROOT_SELECTOR),
      update
    );
  }

  /* Ascultarea sta pe document, nu pe fiecare grup de butoane: continutul
     ferestrei de adaugare rapida e adus prin `innerHTML` dupa apasare, deci
     ascultatorii pusi la incarcare ar fi ramas pe noduri care nu exista inca. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var root = target.closest(ROOT_SELECTOR);
    if (root) update(root);
  });

  function watchQuickView() {
    var wrapper = document.getElementById('quickViewWrapper');
    if (!wrapper || typeof MutationObserver === 'undefined') return;

    new MutationObserver(function () {
      updateAll(wrapper);
    }).observe(wrapper, { childList: true, subtree: true });
  }

  function start() {
    updateAll();
    watchQuickView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
